import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MyUtils } from "src/app/services/my-utils.service";
import { TableAction } from "../../../records/models/table-action";

@Component({
  selector: "app-custom-buttons",
  templateUrl: "./custom-buttons.component.html",
  styleUrls: ["./custom-buttons.component.scss"],
})
export class CustomButtonsComponent<T extends object> implements OnInit {
  @Input() buttons: TableAction<T>[] = [];
  @Input() element: any;

  @Output() buttonClick = new EventEmitter<TableAction<T>>();

  constructor(public utils: MyUtils) { }

  ngOnInit(): void { }

  onClick(button: TableAction<T>) {
    this.buttonClick.emit(button);
  }

  isDisabled(button: TableAction<T>) {
    if (button.command.isDisabled) {
      let isDisabled = button.command.isDisabled(this.element);
      return isDisabled;
    } else {
      return false;
    }
  }
}
